// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2GpME","inner":"Footer_inner__3hiRd","nextIcon":"Footer_nextIcon__3aJzG","innerLeft":"Footer_innerLeft__3ssUC"};